export const createAddressString = (address: (string | undefined)[]) => {
  return address.filter((line) => line !== undefined && line !== '').join(', ');
};
